import hoverintent from './hoverintent.js';
import {isTouchDevice} from "cronus-theme/default/global/js/touchDevice";

export function initItemboxHospitality() {
    if(isTouchDevice()){
        return;
    }
    const HOVERINTENT_DURATION = 100;

    const itemboxes = document.querySelectorAll('.itemboxHospitality');

    if (!itemboxes.length) {
        return;
    }

    for (let itembox of itemboxes) {
        hoverintent(itembox, HOVERINTENT_DURATION);
    }
}